/* LONO: show the cart's shoe size in the size system the customer picked on the product page (EU / US / UK). Display only: variants stay in EU. */
(function(){
if(window.__lonoCartSize)return;window.__lonoCartSize=true;
var MAP={35:['5','','2.5'],36:['5.5','','3'],37:['6','','3.5'],38:['7','','4.5'],39:['8','','5.5'],40:['8.5','7.5','6'],41:['9.5','8.5','7.5'],42:['10','9','8'],43:['11','10','9'],44:['','11','10'],45:['','12','11'],46:['','13','12'],47:['','13.5','12.5'],48:['','14','13']};
function sys(){var v=null;try{v=localStorage.getItem('lono_size_sys')}catch(e){}if(v==='eu'||v==='us'||v==='uk')return v;var c=String((window.Shopify&&window.Shopify.country)||'').toUpperCase();return c==='US'||c==='CA'?'us':(c==='GB'||c==='IE'?'uk':'eu')}
function fmt(eu,s){var r=MAP[eu];if(!r)return null;if(s==='uk')return 'UK '+r[2]+' (EU '+eu+')';var us=r[0]&&r[1]?'US M '+r[1]+' / W '+r[0]:(r[1]?'US M '+r[1]:'US W '+r[0]);return us+' (EU '+eu+')'}
var busy=false,queued=false;
function run(){
  queued=false;busy=true;
  try{
    var s=sys(),els=document.querySelectorAll('line-item .line-item__info p.text-sm.text-subdued');
    for(var i=0;i<els.length;i++){
      var p=els[i],cur=p.textContent.trim(),orig=(p.getAttribute('data-lono-out')===cur)?p.getAttribute('data-lono-orig'):cur;
      var parts=orig.split(' / '),last=parts[parts.length-1],out=orig;
      if(s!=='eu'&&/^\d{2}$/.test(last)&&MAP[last]){out=parts.slice(0,-1).concat(fmt(last,s)).join(' / ')}
      if(out!==cur)p.textContent=out;
      p.setAttribute('data-lono-orig',orig);p.setAttribute('data-lono-out',out);
    }
  }finally{busy=false}
}
function sched(){if(busy||queued)return;queued=true;(window.requestAnimationFrame||setTimeout)(run)}
new MutationObserver(sched).observe(document.documentElement,{childList:true,subtree:true});
window.addEventListener('storage',sched);
document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.lono-size-sys button'))setTimeout(sched,50)});
run();
})();

/* LONO: the mobile sticky "Select Size" bar of the product page stayed on screen on top of the size picker, so the picker showed two buttons (Add to bag + Select Size). Hide the sticky bar while any size picker is open. */
(function(){
if(window.__lonoQbSticky)return;window.__lonoQbSticky=true;
try{
  var s=document.createElement('style');
  s.textContent='body:has(quick-buy-drawer[open]) #vStickyWrapper,body:has(cart-drawer[open]) #vStickyWrapper{opacity:0!important;visibility:hidden!important;pointer-events:none!important}';
  document.head.appendChild(s);
}catch(e){}
})();

/* LONO: "Your order is Tax Free!" banner uses the same light green as the reviews strip (#abed86) for the text and the tick, on the black pill. */
(function(){
if(window.__lonoTaxGreen)return;window.__lonoTaxGreen=true;
try{
  var g=document.createElement('style');
  g.textContent='html body #cart-drawer .lono-tax-banner.lono-tax-banner span{color:#abed86!important}html body #cart-drawer .lono-tax-banner.lono-tax-banner svg{background:#abed86!important}';
  document.head.appendChild(g);
}catch(e){}
})();

/* LONO: free-shipping track. Moving stripes while it fills, a little truck that drives along it, and a solid bar with the truck parked at the end once free shipping is reached. The CSS is added here and the reached state is flagged here (data-lono-reached), because this file has its own cache version. */
(function(){
if(window.__lonoShipTrack)return;window.__lonoShipTrack=true;
try{
  var st=document.createElement('style');
  st.textContent=`free-shipping-bar{display:block}
free-shipping-bar progress-bar.progress-bar{display:block;position:relative;height:10px;margin:14px 0 8px;border-radius:99px;background:rgba(0,0,0,.12);overflow:visible}
free-shipping-bar progress-bar.progress-bar::before{content:"";display:block;height:100%;width:calc(var(--progress,0) * 100%);min-width:10px;border-radius:99px;transform:none;transition:width .7s cubic-bezier(.22,1,.36,1);background:repeating-linear-gradient(135deg,#111 0 8px,#3b3b3b 8px 16px);background-size:22.63px 22.63px;animation:lonoStripe .9s linear infinite}
free-shipping-bar progress-bar.progress-bar::after{content:"";position:absolute;top:50%;left:min(max(calc(var(--progress,0) * 100%),16px),calc(100% - 16px));width:32px;height:32px;margin:-16px 0 0 -16px;box-sizing:border-box;border-radius:50%;background:#111 url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'><rect x='1' y='4' width='14' height='12'/><polygon points='15 8 19.5 8 23 11.5 23 16 15 16 15 8'/><circle cx='6' cy='18.5' r='2.3' fill='%23111'/><circle cx='18.5' cy='18.5' r='2.3' fill='%23111'/></svg>") center/20px no-repeat;box-shadow:0 0 0 3px #fff;transition:left .7s cubic-bezier(.22,1,.36,1);animation:lonoDrive .5s ease-in-out infinite alternate}
free-shipping-bar[data-lono-reached] progress-bar.progress-bar::before{animation:lonoSweep 2.6s ease-in-out infinite;background:linear-gradient(100deg,#111 35%,#555 50%,#111 65%) 0 0/250% 100%}
free-shipping-bar[data-lono-reached] progress-bar.progress-bar::after{animation:lonoDone .6s cubic-bezier(.34,1.56,.64,1) both}
free-shipping-bar[data-lono-reached]>span{font-weight:700}
@keyframes lonoStripe{to{background-position:22.63px 0}}
@keyframes lonoDrive{from{transform:translateY(-1px)}to{transform:translateY(1.5px)}}
@keyframes lonoSweep{0%{background-position:100% 0}100%{background-position:-50% 0}}
@keyframes lonoDone{0%{transform:scale(.5)}60%{transform:scale(1.2)}100%{transform:scale(1)}}
@media (prefers-reduced-motion:reduce){free-shipping-bar progress-bar.progress-bar::before,free-shipping-bar progress-bar.progress-bar::after{animation:none!important;transition:none!important}}`;
  document.head.appendChild(st);
}catch(e){}
function sync(){
  var bars=document.querySelectorAll('free-shipping-bar');
  for(var i=0;i<bars.length;i++){
    var b=bars[i],t=parseFloat(b.getAttribute('threshold')),p=parseFloat(b.getAttribute('total-price'));
    var r=t>0&&p>=t;
    if(r!==b.hasAttribute('data-lono-reached')){if(r)b.setAttribute('data-lono-reached','');else b.removeAttribute('data-lono-reached')}
  }
}
try{
  new MutationObserver(sync).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['total-price','threshold','data-lono-reached']});
}catch(e){}
sync();
})();
